import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Card } from '@hivebrite/design-system/Card';

import AddonCheckbox from '../AddonCheckbox';

const AdditionalItemsForm = ({ addons = [] }) =>
  addons.length > 0 ? (
    <Card bg="white" pt={4} pb={addons.length === 1 ? 6 : 3}>
      <Box font="h3-semibold" mb={3}>
        {__('Additional Items')}
      </Box>
      <Hr />
      <Box flexDirection="column">
        {addons.map((addon, index) => (
          <Box key={addon.id} flexDirection="column">
            <AddonCheckbox
              name={`network_events_booking[addons_attributes][${index}]`}
              addon={addon}
            />
            {index + 1 < addons.length && <AddonHr />}
          </Box>
        ))}
      </Box>
    </Card>
  ) : null;

AdditionalItemsForm.propTypes = {
  addons: PropTypes.array,
};

export default AdditionalItemsForm;

const AddonHr = styled.hr`
  display: block;
  width: 100%;
  margin: ${({ theme }) => theme.space[3]}px 0;
  border-bottom-style: solid;
  border-color: ${({ theme }) => theme.colors.horizon};
`;

const Hr = styled.hr`
  margin-top: 0;
  margin-bottom: ${({ theme }) => theme.space[6]}px;
  border-bottom-style: solid;
  border-color: ${({ theme }) => theme.colors.horizon};
`;
